import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';

import Axios from 'axios';
import _ from 'lodash';

import { PrimeIcons } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';

import Config from '../config';

const VendorDiscounts = () => {
    const [rowsCount, setRowsCount] = useState();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [discount, setDiscount] = useState('');

    const vendorRef = useRef();
    const discountRef = useRef();

    useEffect(() => {
        loadLazyData();
    }, []);

    const loadLazyData = () => {
        setLoading(true);

        Axios.get(Config.API_BASE_URL+"/api/settings/vendor-discounts")
            .then(result => result.data)
            .then(result => {
                setRows(result.data.rows);
                setRowsCount(result.data.count);
                setLoading(false);
            });
    };

    const rowDiscount = row => row.discount+'%';

    const deleteButton = row => (
        <div className="actions">
            <Button
                icon={PrimeIcons.TRASH}
                className="p-button-rounded p-button-danger"
                onClick={() => deleteRow(row)}
            />
        </div>
    );

    const deleteRow = row => {
        setLoading(true);

        Axios.delete(Config.API_BASE_URL+"/api/settings/vendor-discounts/"+row.id)
            .then(() => {
                loadLazyData();
            });
    };

    const addRow = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/settings/vendor-discounts", { vendor: vendorRef.current.value, discount: discountRef.current.value })
            .then(() => {
                vendorRef.current.value = '';
                discountRef.current.value = '';
                loadLazyData();
            });
    };

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Elenco degli sconti per marchio</h5>
                    <DataTable
                      className="p-datatable-gridlines"
                      responsiveLayout="scroll"
                      lazy
                      dataKey="id"
                      value={rows}
                      //paginator
                      showGridlines
                      //first={lazyParams.first}
                      //rows={lazyParams.rows}
                      totalRecords={rowsCount}
                      //filters={lazyParams.filters}
                      //filterDisplay="row"
                      //onFilter={onFilter}
                      //sortField={lazyParams.sortField}
                      //sortOrder={lazyParams.sortOrder}
                      //onSort={onSort}
                      //onPage={onPage}
                      loading={loading}
                      emptyMessage="Nessuno sconto trovato."
                    >
                      <Column key="vendor" header="Marchio" field="vendor" /*filter showFilterMenu={false} style={{ maxWidth: '100px' }}*/ />
                      <Column field="discount" body={rowDiscount} header="Sconto" style={{ maxWidth: '100px' }} />
                      <Column body={deleteButton} style={{ maxWidth: '50px' }} />
                    </DataTable>
                </div>

                <div className="card">
                    <h5>Aggiungi uno sconto per marchio</h5>
                    <div className="formgroup-inline">
                        <div className="field">
                            <label htmlFor="vendor" className="p-sr-only">Marchio</label>
                            <InputText ref={vendorRef} id="vendor" type="text" placeholder='Marchio' />
                        </div>
                        <div className="field">
                            <label htmlFor="discount" className="p-sr-only">Sconto</label>
                            <InputText ref={discountRef} id="discount" type="text" placeholder='%' />
                        </div>
                        <Button label="Submit" onClick={() => addRow()}></Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(VendorDiscounts, comparisonFn);
